import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Table, TableName } from '@openx/components-table/Table.tsx';
import { useTranslation } from 'react-i18next';
import { useDealInsightsContext } from '../../../../context/DealInsightsContext.tsx';
import { NoDataComponent } from '../../../shared/NoDataComponent.tsx';
import { useDeliveryByAdDurationTableColumns } from './hooks/useDeliveryByAdDurationTableColumns.tsx';
import { useDeliveryByAdDurationTableData } from './hooks/useDeliveryByAdDurationTableData.ts';

export const DeliveryByAdDurationTable = () => {
  const { dealInsights, criteria, handleCriteriaChange } = useDealInsightsContext();
  const { data: rawData } = dealInsights;
  const { t } = useTranslation();
  const theme = useTheme();
  const { data, isLoading } = useDeliveryByAdDurationTableData();

  const { columns } = useDeliveryByAdDurationTableColumns({
    impressions: {
      max: rawData?.delivery_by_ad_duration.impressions_range.maximum ?? 0,
      min: rawData?.delivery_by_ad_duration.impressions_range.minimum ?? 0,
      color: theme.palette.charts.indigo,
    },
    spend: {
      max: rawData?.delivery_by_ad_duration.spend_range.maximum ?? 0,
      min: rawData?.delivery_by_ad_duration.spend_range.minimum ?? 0,
      color: theme.palette.charts.lightBlue,
    },
    sov: {
      max: rawData?.delivery_by_ad_duration.sov_range.maximum ?? 0,
      min: rawData?.delivery_by_ad_duration.sov_range.minimum ?? 0,
      color: theme.palette.charts.purple,
    },
    viewability: {
      max: 1,
      min: 0,
      color: theme.palette.charts.pink,
    },
    ecpm: {
      max: rawData?.delivery_by_ad_duration.ecpm_range.maximum ?? 0,
      min: rawData?.delivery_by_ad_duration.ecpm_range.minimum ?? 0,
      color: theme.palette.charts.blue,
    },
    ctr: {
      max: rawData?.delivery_by_ad_duration.ctr_range.maximum ?? 0,
      min: rawData?.delivery_by_ad_duration.ctr_range.minimum ?? 0,
      color: theme.palette.charts.canary,
    },
  });

  return (
    <Stack>
      <Box
        sx={{
          px: 4,
          pt: 4,
          pb: 1,
          borderBottom: theme => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Typography variant="h2">{t('Delivery by Ad Duration [Video Only]')}</Typography>
      </Box>

      <Table
        data-test="deal-insights-delivery-by-ad-duration-table"
        data={data}
        columns={columns}
        loading={isLoading}
        criteria={criteria[TableName.DEAL_INSIGHTS_DELIVERY_BY_AD_DURATION]}
        name={TableName.DEAL_INSIGHTS_DELIVERY_BY_AD_DURATION}
        onCriteriaChange={newCriteria =>
          handleCriteriaChange(newCriteria, TableName.DEAL_INSIGHTS_DELIVERY_BY_AD_DURATION)
        }
        overrideTableCellStyles={{ padding: 0 }}
        skeletonRows={10}
        customNoDataComponent={NoDataComponent}
        stickyActionColumn
      />
    </Stack>
  );
};
